import { render } from "./backBtn.vue?vue&type=template&id=bca403fc&scoped=true"
import script from "./backBtn.vue?vue&type=script&lang=js"
export * from "./backBtn.vue?vue&type=script&lang=js"

import "./backBtn.vue?vue&type=style&index=0&id=bca403fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca403fc"]])

export default __exports__